import {Button, Modal} from 'react-bootstrap'
import {AddValidation} from '../../oneUser/components/activityTab/AddValidation'
import {NodeValidations} from '../../../graphql/types/validationsTypes'

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  info: NodeValidations | null
}

export const ModalAddValidation: React.FC<IModalProps> = ({isOpen, onClose, refetch, info}) => {
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header onHide={onClose}>
        <Modal.Title>{info ? 'Editar' : 'Agregar'} validación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddValidation
          id={info ? info.id : undefined}
          dataPrev={info || undefined}
          refetch={refetch}
          onToggleSubTab={onClose}
          hiddenEffect
          cancelBtn={
            <Button variant='outline' onClick={onClose}>
              Cancelar
            </Button>
          }
        />
      </Modal.Body>
    </Modal>
  )
}
